export const authProviders = {
  // amazon: 'Amazon',
  amazon: 'LoginWithAmazon',
  email: 'EmailAndPassword',
  facebook: 'Facebook',
  google: 'Google',
};

export const cognitoPrefix = 'CognitoIdentityServiceProvider';

export const restApiName = 'web-api';

export const validEmail = 'blackbeltwilbur@gmail.com';
// noinspection SpellCheckingInspection
export const validMemberId = '01ES6VZ9WVYZW18B3TP683NEK5';
export const validUsername = validEmail;
export const validPassword = '1Password!';
// blackbeltwilbur+007@gmail.com